<template>
  <div class="vue__payment-hdp-sepa">
    <payment-hdp-form v-on:submit="submit">
      <div v-bind:id="ibanId" class="field">
        <!-- The IBAN field UI Element will be inserted here -->
      </div>
    </payment-hdp-form>
  </div>
</template>

<script>
import { onMounted, unref } from "vue";

import createHeidelpayInstance from "../../lib/create-heidelpay-instance";
import createUniqueId from "../../lib/create-unique-id";

export default {
  setup(props, { emit }) {
    // Creating a credit card instance
    const heidelpayInstance = createHeidelpayInstance();
    const Sepa = heidelpayInstance.SepaDirectDebit();

    const ibanId = createUniqueId();

    onMounted(() => {
      // Rendering input fields
      Sepa.create("sepa-direct-debit", {
        containerId: unref(ibanId),
        onlyIframe: false,
      });
    });

    const submit = async (elementControl) => {
      try {
        elementControl(false);
        const result = await Sepa.createResource();
        emit("pay", result, elementControl);
      } catch (error) {
        console.error("Error while submitting heidelpay form", error);
        elementControl(true);
      }
    };

    return {
      // static data:
      ibanId,

      // methods:
      submit,
    };
  },
};
</script>
